import React from 'react';

class VerticalLinkCollection extends React.Component {
   
   constructor(props)
   {
      super(props);
      var defaultElemStyle = {
         textDecoration: 'underline',

      }

      var defaultCollectionStyle = {
         textDecoration: 'underline',

      }
      this.elemStyle = props.elemStyle ?
      props.elemStyle : defaultElemStyle;

      this.collectionStyle = props.collectionStyle ?
      props.collectionStyle : defaultCollectionStyle;

      this.clickCallbackToMaker = this.props.clickElemCallback;

      this.clickElemCallback = function(elemData)
      {
         this.clickCallbackToMaker(elemData);
      }.bind(this);

   }
	
   render() {

      return (
         <div style={this.collectionStyle}>
            {this.props.links.map((lnk, i) => 
               <LinkElem key = {i} data = {lnk} elemStyle={this.elemStyle}
               cB = {this.clickElemCallback} />)}
         </div>
      );
   }
}

export default VerticalLinkCollection;

class LinkElem extends React.Component
{
  constructor(props)
  {
      super(props);
      
      this.elemStyle = props.elemStyle;

      this.cB = function()
      {
         this.props.cB(this.props.data);
      }.bind(this);
  }
   render() {

      var btnStyle = {
          padding: '0 0 10px 0',
         background: this.props.isCurrent ? this.activeColor : this.inactiveColor,
         listStyle: 'none',
         cursor: 'pointer',
      }
      return (
            <div style={btnStyle} onClick = {this.cB}>{this.props.data.name}</div>
      )
   }
}


// WEBPACK FOOTER //
// ./js/VerticalLinkCollection.jsx